<template>
  <div class="page_container warehousingRecordPage">
    <div class="screen_wrap flex-rowl">
      <div class="add_box flex-rowl" @click="handleGo('', 'cSelectMsgEdit')">
        {{ $t("Add example") }}
        <el-image
          style="width: 21px; height: 21px"
          :src="require('@/assets/images/add_selectMsg_icon.png')"
        ></el-image>
      </div>
      <div class="query_box flex-rowl">
        <div class="label flex-rowl">{{ $t("Product type") }}</div>
        <div class="select_box flex-rowl" @click="isLabelShow = true">
          <p :class="{ active: label2Str }">
            {{
              label2Str ? label2Str : $t("Click to select the product category")
            }}
            <span v-if="label3Str">、{{ label3Str ? label3Str : "" }}</span>
          </p>
          <span class="iconfont icon-sanjiaojiantoushang"></span>
        </div>
      </div>
      <div class="rest_box flex-rowl" @click="handleRest">
        {{ $t("Reset search results") }}
        <i class="iconfont icon-shuaxin-2"></i>
      </div>
    </div>
    <div class="main_container">
      <div
        class="list_wrap flex-rowl"
        v-loading="loading"
        :element-loading-text="$t('Please wait')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
      >
        <template v-if="dataList.length > 0">
          <div
            class="item_wrap flex-rowl"
            v-for="item in dataList"
            :key="item.id"
          >
            <div class="pic_box">
              <el-image
                style="width: 150px; height: 325px"
                :src="item.pic"
                fit="cover"
                :preview-src-list="item.bannerList"
              >
                <div slot="error" class="image-slot flex-rowc">
                  <i class="iconfont icon-zanwutupian1"></i>
                </div>
              </el-image>
            </div>
            <div class="intro_box">
              <div class="block">
                <p class="small ellipsis-multiline">
                  {{ item.multilingualCommodityname }}
                </p>
              </div>
              <div class="block">
                <p class="small">{{ $t("Product category") }}：</p>
                <p
                  class="small"
                  v-for="(itemChild, indexChild) in item.newLabel"
                  :key="indexChild"
                >
                  {{ itemChild.multilingualName }}
                </p>
              </div>
              <div class="block">
                <p class="small">{{ COUNTRY.countryname_e }}</p>
                <p class="small">{{ item.channelstr }}</p>
                <p class="small">{{ item.sellerid }}</p>
              </div>
              <div class="block">
                <p>{{ $t("Price") }}</p>
                <p>
                  ( {{ USERINFO.countryExrateObj.moneyslog }} ) :{{
                    item.pricemin
                  }}/{{ item.pricemax }}
                </p>
              </div>
              <div class="block">
                <p>
                  {{ $t("Volume") }}：<span>{{ item.goodtalk }}</span>
                </p>
                <p>
                  {{ $t("Evaluation") }}：<span>{{ item.sellnum }}</span>
                </p>
              </div>
              <div
                class="shop_operation_wrap flex-rowl"
                v-if="item.specialopenid == OPENID"
              >
                <div @click="handleGo(item.id, 'cSelectMsgEdit')">
                  <el-image
                    style="width: 19px; height: 20px"
                    :src="require('@/assets/images/edit_icon.png')"
                  ></el-image>
                </div>
              </div>
            </div>
          </div>
        </template>
        <div
          class="empty_box flex-rowc"
          v-if="!loading && dataList.length == 0"
        >
          <el-empty :description="$t('No data yet')"></el-empty>
        </div>
      </div>
    </div>

    <!-- 分页 start -->
    <div class="pagination_wrap flex-rowc">
      <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
        :page-size="9"
        :total="listTotal"
      >
      </el-pagination>
    </div>
    <!-- 分页 end -->

    <!-- 标签 -->
    <div class="custom_dialog" v-show="isLabelShow">
      <div class="custom_wrap">
        <div class="diaog_head">
          <div class="close_icon" @click="isLabelShow = false">
            <i class="iconfont icon-guanbi"></i>
          </div>
          <h1>{{ $t("Product type") }}：</h1>
        </div>

        <div class="diaog_body">
          <div class="radio_wrap">
            <div class="radio_group flex-rowl mb_30">
              <div class="radio_item flex-rowl" @click="handleLabelItem('')">
                <i
                  class="iconfont"
                  :class="
                    params.labelid2 == ''
                      ? 'icon-danxuanyixuan1'
                      : 'icon-quanxuan'
                  "
                ></i>
                {{ $t("Reset search results") }}
              </div>
            </div>
            <div class="radio_group mb_30">
              <p>{{ $t("Secondary classification") }}</p>
              <div class="radio_list flex-rowl">
                <div
                  class="radio_item flex-rowl"
                  v-for="item in label2Arr"
                  :key="item.id"
                  @click="handleLabelItem(item.id, 'label2', item)"
                >
                  <i
                    class="iconfont"
                    :class="
                      params.labelid2 == item.id
                        ? 'icon-danxuanyixuan1'
                        : 'icon-quanxuan'
                    "
                  ></i>
                  {{ item.multilingualName }}
                </div>
              </div>
            </div>

            <div class="radio_group" v-if="label3Arr.length > 0">
              <p>{{ $t("Tertiary classification") }}</p>
              <div class="radio_list flex-rowl">
                <div
                  class="radio_item flex-rowl"
                  v-for="item in label3Arr"
                  :key="item.id"
                  @click="handleLabelItem(item.id, 'label3', item)"
                >
                  <i
                    class="iconfont"
                    :class="
                      params.labelid3 == item.id
                        ? 'icon-danxuanyixuan1'
                        : 'icon-quanxuan'
                    "
                  ></i>
                  {{ item.multilingualName }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { encryptstringadd, getCommondityLabel } from "../../api/api";
import { getShopSelectMsgList } from "../../api/shop";
import { mapState } from "vuex";
import storage from "../../utils/storage";
import Clipboard from "clipboard";
export default {
  name: "selectMsgList",
  data() {
    return {
      loading: false,
      dataList: [],
      params: {
        pageindex: 1,
        pagesize: 12,
        keyword: "",
        countryids: "",
        labelid: "f23677a3e21742ba8ef11c3b1ea761ab",
        labelid2: "",
        labelid3: "",
      },
      label2Str: "",
      label3Str: "",

      qyStr: "",
      listTotal: 0,

      isLabelShow: false,
      label2Arr: [], // 二级标签列表
      label3Arr: [], // 三级标签列表
    };
  },
  computed: {
    ...mapState(["TOKEN", "OPENID", "USERINFO", "COUNTRY"]),
  },
  created() {
    this.params.countryids = this.COUNTRY.countryid;
    this.initData();
    this.getCommondityLabel();
  },
  methods: {
    handleMultilingualName(dataList, key1, key2, key3, key4) {
      let { countryid } = this.COUNTRY;
      dataList.forEach((v) => {
        if (countryid == 1) {
          v.multilingualName = v[key1];
        } else if (countryid == 8) {
          // 英文
          v.multilingualName = v[key2] ? v[key2] : v[key1];
        } else if (countryid == 2) {
          // 俄语
          v.multilingualName = v[key3] ? v[key3] : v[key2] ? v[key2] : v[key1];
        } else if (countryid == 4) {
          // 越语
          v.multilingualName = v[key4] ? v[key4] : v[key2] ? v[key2] : v[key1];
        }
      });
      return dataList;
    },

    handleCurrentChange(e) {
      this.params.pageindex = e;
      this.dataList = [];
      this.initData();
    },

    // 获取商品分类标签
    getCommondityLabel() {
      getCommondityLabel().then((res) => {
        // 一级标签为“服饰&穿戴”
        let filter = res.filter(
          (v) => v.id == "f23677a3e21742ba8ef11c3b1ea761ab"
        );

        // 不同国家选择多语言
        let MultilingualArr = this.handleMultilingualName(
          filter[0].childs2,
          "labelname",
          "labelname_e",
          "labelname_m",
          "labelname_y"
        );
        this.label2Arr = MultilingualArr.filter((v) => v.labelstate == 1).sort(
          (a, b) => a.sort - b.sort
        );
      });
    },

    initData() {
      let { params } = this;
      this.loading = true;
      getShopSelectMsgList(params).then((res) => {
        console.log(res);
        if (res.msg != "" && res.msg) {
          let message = this.$message({
            message: this.$t("Login status has expired, please log in again"),
            center: true,
            type: "warning",
          });
          // let message = this.$message.success(res.msg);
          setTimeout(() => {
            storage.removeAll();
            this.$router.push("/login");
            message.close();
          }, 800);
        } else {
          res.list.forEach((v) => {
            // 不同国家选择多语言
            if (params.countryids == 1) {
              v.multilingualCommodityname = v.commodityname;
            } else if (params.countryids == 8) {
              // 英文
              v.multilingualCommodityname = v.commodityname_e
                ? v.commodityname_e
                : v.commodityname;
            } else if (params.countryids == 2) {
              // 俄语
              v.multilingualCommodityname = v.commodityname_m
                ? v.commodityname_m
                : v.commodityname;
            } else if (params.countryids == 4) {
              // 越语
              v.multilingualCommodityname = v.commodityname_y
                ? v.commodityname_y
                : v.commodityname;
            }

            const filteredArr = Object.keys(v)
              .filter((key) => key.startsWith("pic"))
              .map((key) => v[key]);
            v.bannerList = filteredArr.filter(
              (item) => item !== null && item !== undefined && item !== ""
            );

            let newLabelArr = [];
            v.labelid_list.forEach((v) => {
              newLabelArr.push(v);
            });
            v.labelid2_list.forEach((v) => {
              newLabelArr.push(v);
            });
            v.labelid3_list.forEach((v) => {
              newLabelArr.push(v);
            });
            // 不同国家选择多语言
            let MultilingualArr = this.handleMultilingualName(
              newLabelArr,
              "typename",
              "labelcont_e",
              "labelcont_m",
              "labelcont_y"
            );
            v.newLabel = MultilingualArr;
          });

          this.listTotal = res.total;
          this.dataList = res.list;
          this.loading = false;
        }
      });
    },

    handleRest() {
      this.params.labelid2 = "";
      this.params.labelid3 = "";
      this.label2Str = "";
      this.label3Str = "";
      this.initData();
    },

    // 标签选择
    handleLabelItem(id, type, item) {
      if (id == "") {
        this.params.labelid2 = "";
        this.params.labelid3 = "";
        this.label2Str = "";
        this.label3Str = "";
        this.label3Arr = [];
        this.initData();
        this.isLabelShow = false;
        return;
      }
      let { label2Arr } = this;
      if (type == "label2") {
        this.params.labelid2 = id;
        this.label2Str = item.multilingualName;

        let filterArr = label2Arr.filter((v) => v.id == id)[0];
        if (filterArr.childs3.length > 0) {
          // 不同国家选择多语言
          let MultilingualArr = this.handleMultilingualName(
            filterArr.childs3,
            "labelname",
            "labelname_e",
            "labelname_m",
            "labelname_y"
          );
          this.label3Arr = MultilingualArr.filter(
            (v) => v.labelstate == 1
          ).sort((a, b) => a.sort - b.sort);
        } else {
          this.initData();
          this.isLabelShow = false;
        }
        //
      } else if (type == "label3") {
        this.params.labelid3 = id;
        this.label3Str = item.multilingualName;
        this.initData();
        this.isLabelShow = false;
      }
    },

    handleGo(id, name) {
      this.encryptstringadd(name, { id });
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
          // window.open(this.$router.resolve({ name, params }).href, "_blank");
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },

    handleReturn() {
      this.$router.back();
    },

    // 复制
    handleCopyBtn() {
      let clipboard = new Clipboard(".copy_box");
      clipboard.on("success", () => {
        // console.log("复制成功",e);
        this.$message.success(this.$t("Copy successful"));
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制", e);
        if (e.text) {
          this.$message.warning("SAO chép không thành công");
        } else {
          // this.$toast("暂无内容");
        }
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>
  <style lang="less" scoped>
.page_container {
  padding: 0;
  min-height: 88vh;
  height: 88vh;
  .screen_wrap {
    font-size: 16px;
    color: #5b5b5b;
    margin-bottom: 30px;
    .add_box {
      cursor: pointer;
      .el-image {
        margin-left: 10px;
      }
    }
    .query_box {
      // span {
      //   width: 25%;
      //   white-space: nowrap;
      // }
      // width: 25%;
      flex-shrink: 0;
      margin-right: 20px;
      margin-left: 30px;
      .label {
        height: 100%;
        white-space: nowrap;
        margin-right: 10px;
      }
      height: 36px;
      .select_box,
      .input_box {
        flex: 1;
        height: 36px;
        background: #e6e6e6;
        border-radius: 45px;
        position: relative;
        cursor: pointer;
        padding: 0 30px 0 10px;
        box-sizing: border-box;
        p {
          font-size: 14px;
          color: #acacac;
          width: 100%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          &.active {
            color: #303030;
          }
        }
        /deep/ .el-input__inner {
          background: transparent;
          height: 36px;
          line-height: 36px;
          border: none;
          padding: 0;
        }
        /deep/ .el-select .el-input .el-select__caret {
          color: #e6e6e6;
        }
        .iconfont {
          position: absolute;
          right: 15px;
          color: #acacac;
        }
        &.label_box {
          width: 200px;
        }
      }
      .input_box {
        .iconfont {
          right: 10px;
          cursor: pointer;
        }
      }
      &:last-child {
        margin-right: 0;
      }
    }
    .rest_box {
      cursor: pointer;
      .iconfont {
        margin-left: 5px;
      }
    }

    .ordertype_box {
      margin: 0 100px 0 84px;
      .iconfont {
        font-size: 20px;
      }
    }
    .brand_box {
      .select_box {
        width: 300px;
        height: 36px;
        background: #e6e6e6;
        margin-left: 11px;
        border-radius: 45px;
        position: relative;
        cursor: pointer;
        span {
          font-size: 14px;
          color: #acacac;
          margin-left: 20px;
        }
        /deep/ .el-input__inner {
          background: transparent;
          height: 36px;
          line-height: 36px;
          border: none;
        }
        /deep/ .el-select .el-input .el-select__caret {
          color: #e6e6e6;
        }
        // span {
        //   position: absolute;
        //   right: 14px;
        //   top: 50%;
        //   transform: translateY(-50%);
        //   color: #666666;
        // }
      }
    }
  }
  .list_wrap {
    height: auto;
    align-items: flex-start;
    flex-flow: wrap;
    min-height: 80vh;

    .item_wrap {
      background: none;
      width: calc((100% - 120px) / 4);
      align-items: flex-start;
      margin-bottom: 50px;
      margin-right: 40px;
      flex-shrink: 0;
      box-sizing: border-box;
      &:nth-child(4n) {
        margin-right: 0;
      }
      .pic_box {
        width: 150px;
      }
      .intro_box {
        margin: 0 0 0 20px !important;
        flex: 1;
      }
      .block {
        margin-bottom: 10px;

        .copy_box {
          cursor: pointer;
        }
        p {
          font-size: 16px;
          color: #333333;
          line-height: 18px;
          line-break: anywhere;
          &.small {
            font-size: 14px;
            line-height: 15px;
            margin-bottom: 5px;
          }
        }
      }
      .shop_operation_wrap {
        margin-top: 15px;
        div {
          cursor: pointer;
          &:nth-child(2n) {
            margin: 0 20px;
          }
        }
      }
    }
    .empty_box {
      width: 100%;
      height: 100%;
    }
  }
  .custom_dialog {
    .diaog_head {
      height: 60px;
    }
    .diaog_body {
      height: calc(68vh - 110px);
      .radio_wrap {
        .radio_group {
          p {
            margin-bottom: 20px;
          }
          .radio_list {
            flex-wrap: wrap;
          }
          .radio_item {
            margin-right: 80px;
            font-size: 14px;
            color: #6e6e6e;
            margin-bottom: 20px;
            cursor: pointer;
            .iconfont {
              font-size: 22px;
              margin-right: 5px;
              color: #a5a5a5;
              &.icon-danxuanyixuan1 {
                color: #ea4e4e;
              }
            }
          }
          &.mb_30 {
            margin-bottom: 20px;
          }
        }
      }
    }
  }
  .rest_wrap {
    font-size: 12px;
    cursor: pointer;
    color: #444;
    height: 35px;
    border: 1px solid #d8d8d8;
    border-radius: 20px;
    padding: 0 14px 0 28px;
    box-sizing: border-box;
    margin-left: 20px;
    span {
      margin-right: 10px;
    }
  }
  .main_container {
    height: 55vh;
    overflow-y: scroll;
    // 隐藏滚动条
    &::-webkit-scrollbar {
      display: none;
    }
  }

  .radio_list {
    flex-wrap: wrap;
  }
}
</style>